/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add, subtract, multiply or divide two fractions. Enter a numerator and denominator for each, pick an operation, and the answer is reduced to lowest terms.`)
};

const es_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplaza cada ocurrencia de una palabra o patrón en tu texto — con coincidencia literal o expresión regular, opciones de sin distinción de mayúsculas y solo palabras completas.`)
};

const de_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzen Sie jedes Vorkommen eines Worts oder Musters in Ihrem Text — mit wörtlicher oder regulärer Ausdrucks-Übereinstimmung, mit Optionen für Groß-/Kleinschreibung und ganze Wörter.`)
};

const nl_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervang elk voorkomen van een woord of patroon in uw tekst — met letterlijke of reguliere-expressiebijpassingen, niet-hoofdlettergevoelig en alleen-hele-woord-opties.`)
};

const fr_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacez chaque occurrence d'un mot ou d'un modèle dans votre texte — avec correspondance littérale ou expression régulière, options insensibles à la casse et mot entier.`)
};

const it_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisci ogni occorrenza di una parola o schema nel tuo testo — con corrispondenza letterale o espressione regolare, opzioni di ricerca senza distinzione tra maiuscole e minuscole e solo parola intera.`)
};

const pt_br2_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitua todas as ocorrências de uma palavra ou padrão em seu texto — com correspondência literal ou por expressão regular, com opções de distinção de maiúsculas/minúsculas e palavra completa.`)
};

const pt_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitua cada ocorrência de uma palavra ou padrão no seu texto — com correspondência literal ou de expressão regular, opções de insensibilidade a maiúsculas e palavras inteiras.`)
};

const ja_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト内の単語またはパターンのすべての出現を置換します — 文字列または正規表現で、大文字小文字を区別しない、単語全体のみのオプション付き。`)
};

const zh_fr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替换文本中每一处出现的单词或模式 — 支持字面文本或正则表达式匹配，可选不区分大小写和仅匹配整个单词。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_intro", locale)
	if (locale === "en") return en_fr_intro(inputs)
	if (locale === "es") return es_fr_intro(inputs)
	if (locale === "de") return de_fr_intro(inputs)
	if (locale === "nl") return nl_fr_intro(inputs)
	if (locale === "fr") return fr_fr_intro(inputs)
	if (locale === "it") return it_fr_intro(inputs)
	if (locale === "pt-BR") return pt_br2_fr_intro(inputs)
	if (locale === "pt") return pt_fr_intro(inputs)
	if (locale === "ja") return ja_fr_intro(inputs)
	return zh_fr_intro(inputs)
};